import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousands',
  pure: true,
})
export class ThousandsPipe implements PipeTransform {
  transform(value: string) {
    if (value.endsWith(',000')) {
      return value.substring(0, value.length - 4) + 'k';
    } else {
      return value;
    }
  }
}
